import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { ServiceRouter } from '@pershing/pershing-core';
import { Observable } from 'rxjs';
import { NXIRestServiceDefinition } from './NXI-Rest-service-definition';
import { AlertServiceDefinition } from './alert-service-definition';
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    })
};
@Injectable()
export class QuickQuoteService {
  
    private modSymbolLookupUrl = '';
    private queryString = '/lookup?symbol=';
    private symbolDataQuery = '/quickquote?symbol=';
    alertsServiceUrl: string;
    private baseUrl: string;
    constructor(private serviceRouter: ServiceRouter, private http: HttpClient, @Optional() @Inject('AppSettings') appSettings: any) {
        this.modSymbolLookupUrl = appSettings.ibdConfigMap.modApiUrl + '/public';
        this.baseUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
        this.alertsServiceUrl = this.serviceRouter.getServiceRouteURL(AlertServiceDefinition.getInstance(), {ignoreOptions: { serviceVersion: true, region: true } });
    
        this.baseUrl += '/portfolio';
    }
    getModSymbolLookupResponse(symbol: string): Observable<any> {
        return this.http.jsonp(this.modSymbolLookupUrl + this.queryString + symbol, 'callback');
    }
    getModSymbolData(symbol: string): Observable<any> {
        return this.http.jsonp(this.modSymbolLookupUrl + this.symbolDataQuery + symbol, 'callback');
    }
    getAgreementDetails(): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/agree' + '?time=' + timeNow);
    }
    getUserPreference(): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/getUseRealTimePref' + '?time=' + timeNow);
    }
    setUserPreference(isRealTime: boolean): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/setUseRealTimePref?pref=' + isRealTime + '?time=' + timeNow);
    }
    getRealTimeKey(symbol: string): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.baseUrl + '/' + symbol + '/modquote/R' + '?time=' + timeNow);
    }
    getModSymbolDataRT(data: string): Observable<any> {
        return this.http.jsonp(this.modSymbolLookupUrl + '/quickquote?YYY2340_' + data, 'callback');
    }
    
    setMarketAlertsAggrement(): Observable<any> {
        return this.http.post<any>(this.alertsServiceUrl + 'alert-agreement', {}, httpOptions);
    }
}
